export const PRIVATE_POLICY = "privatePolicy";
export const USER_AGREEMENT = "userAgreement";
export const ACTIVE_LANG = "activeLanguage";
export const PAGE_PATH = "page_path";